import { render, staticRenderFns } from "./SpErrorPage.vue?vue&type=template&id=84019e78&"
import script from "./SpErrorPage.vue?vue&type=script&lang=ts&"
export * from "./SpErrorPage.vue?vue&type=script&lang=ts&"
import style0 from "./SpErrorPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports